import { render, staticRenderFns } from "./Side.vue?vue&type=template&id=5b57f902&"
import script from "./Side.vue?vue&type=script&lang=ts&"
export * from "./Side.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports